<!-- 
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div id="Articles">

    <page-loader v-if="loading"></page-loader>

    <div v-if="!loading" class="Articles-row">
      <div
        class="article-col article-side"
        :class="[toggleArticle ? articlesRow : '']"
      >
        <div class="articles-section">
          <div class="row">
            <template v-for="article in getArticles.content">
              <div class="col-xl-6 col-lg-12 col-md-6" :key="article.id">
                <b-link
                  :to="{ name: 'Article', params: { id: article.id_article, article: article } }"
                >
                  <div
                    class="article-box"
                    :id="article.id"
                    :class="{
                      current_toggled_article: articleToShow
                        ? article.id === articleToShow.id
                        : '',
                    }"
                  >
                    <div class="article-thumb">
                      <img
                        :src="`data:image/png;base64,${article.img}`"
                        alt="img"
                      />
                    </div>
                    <div class="article-meta">
                      <h3 class="article-title">
                        {{ article.title }}
                      </h3>
                      <p class="article-excerpt">
                        {{ article.extract }}
                      </p>
                      <span class="article-date">
                        {{
                          article.category +
                          ", " +
                          moment(article.date_creation).format(
                            "DD/MM/YYYY HH:mm"
                          )
                        }}
                      </span>
                    </div>
                  </div>
                </b-link>
              </div>
            </template>
          </div>

          <pagination
            :length="length"
            :rows="rows"
            :perPage="perPage"
            :currentPage="currentPage"
            v-on:changePerPage="changePerPage($event)"
            v-on:changeCurrentPage="changeCurrentPage($event)"
          ></pagination>
        </div>
      </div>
      <!-- <div
        class="article-col details-side"
        :class="[
          isSticky ? stickyClass : '',
          toggleArticle ? 'toggleSide' : '',
        ]"
      >
        <div class="article-detail">
          <template v-if="articleToShow">
            <div class="article-detail_header">
              <button class="closeArticle" @click="toggleArticleSide(null)">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path
                    d="M13.41,12l4.3-4.29a1,1,0,1,0-1.42-1.42L12,10.59,7.71,6.29A1,1,0,0,0,6.29,7.71L10.59,12l-4.3,4.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l4.29,4.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z"
                  ></path>
                </svg>
              </button>
              <h3 class="detail_header_title">Détails</h3>
              <div class="article-thumb">
                <img
                  :src="`data:image/png;base64,${this.articleToShow.img}`"
                  alt=""
                />
              </div>
              <span class="article-date">
                {{
                  articleToShow.category +
                  ", " +
                  moment(articleToShow.date_creation).format("DD/MM/YYYY HH:mm")
                }}
              </span>
            </div>
            <div class="article-detail_content_wrap">
              <div class="article-detail_content">
                <h3 class="article-detail_title">
                  {{ articleToShow.title }}
                </h3>
                <div class="article-detail_text">
                  <p v-html="articleToShow.content"></p>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Pagination from "../../components/static/Pagination.vue";
import PageLoader from '../../components/static/pageLoader.vue'

export default {
  name: "ArticlesList",
  components: { Pagination, PageLoader },
  //   props: ['title', 'reglementaires', 'isLoadingFile'],
  data() {
    return {
      loadingReg: false,
      isLoadingFile: {
        loading: false,
        id: null,
      },
      news: null,
      info_fiche: null,
      models: null,
      isSticky: false,
      stickyClass: "is_sticky",
      articlesRow: "toggledArticle",
      scrollPosition: 0,
      toggleArticle: false,
      closeArticle: false,
      articleToShow: null,
      perPage: 6,
      currentPage: 1,
      length: [10, 25, 50],
      sortBy: "creationDate",
      sortDir: false,
    };
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    ...mapGetters("regulation", ["getArticles"]),
    ...mapGetters("loader", { loading: "getLoading" }),
    rows() {
      return this.getArticles.totalElements;
    },
  },
  mounted() {
    this.getArticlesAction({
      currentPage: this.currentPage,
      perPage: this.perPage,
      sortBy: this.sortBy,
      sortDir: this.sortDir,
    });
  },
  methods: {
    ...mapActions("regulation", ["getArticlesAction"]),
    handleScroll(event) {
      const width = window.innerWidth;

      if (width >= 992) {
        this.scrollPosition = window.scrollY;
        if (this.scrollPosition >= 220 && this.toggleArticle) {
          this.isSticky = true;
        } else {
          this.isSticky = false;
        }
      } else {
        this.isSticky = false;
      }
    },
    changePerPage(perPage) {
      this.currentPage = 1;
      this.perPage = perPage;
      this.getArticlesAction({
        currentPage: this.currentPage,
        perPage: this.perPage,
        sortBy: this.sortBy,
        sortDir: this.sortDir,
      });
    },
    changeCurrentPage(currentPage) {
      this.currentPage = currentPage;
      this.getArticlesAction({
        currentPage: this.currentPage,
        perPage: this.perPage,
        sortBy: this.sortBy,
        sortDir: this.sortDir,
      });
    },
  },
};
</script> -->
